export default __webpack_public_path__ + "static/media/diaclean-dialyzer.aee39b49.jpg";